import { Companion_getInstance3d08n7snrwep7 as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from './http/Http.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(operation) {
        this.h42_1 = operation;
        this.i42_1 = null;
        this.j42_1 = Companion_getInstance().u42_1;
        this.k42_1 = null;
        this.l42_1 = null;
        this.m42_1 = null;
        this.n42_1 = null;
        this.o42_1 = null;
        this.p42_1 = null;
        this.q42_1 = null;
        this.r42_1 = null;
        this.s42_1 = null;
        this.t42_1 = true;
      }
      v42(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.i42_1 = requestUuid;
        return this;
      }
      w42(executionContext) {
        // Inline function 'kotlin.apply' call
        this.j42_1 = executionContext;
        return this;
      }
      x42(ignoreApolloClientHttpHeaders) {
        // Inline function 'kotlin.apply' call
        this.q42_1 = ignoreApolloClientHttpHeaders;
        return this;
      }
      y42(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.k42_1 = httpMethod;
        return this;
      }
      z42(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.l42_1 = httpHeaders;
        return this;
      }
      a43(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp = this;
        var tmp0_elvis_lhs = this.l42_1;
        tmp.l42_1 = plus(tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs, new (HttpHeader())(name, value));
        return this;
      }
      b43(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.n42_1 = sendApqExtensions;
        return this;
      }
      c43(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.o42_1 = sendDocument;
        return this;
      }
      d43(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.m42_1 = enableAutoPersistedQueries;
        return this;
      }
      e43(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.p42_1 = canBeBatched;
        return this;
      }
      f43(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.r42_1 = retryOnError;
        return this;
      }
      g43(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.s42_1 = failFastIfOffline;
        return this;
      }
      h43(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.t42_1 = sendEnhancedClientAwareness;
        return this;
      }
      p37() {
        var tmp0_elvis_lhs = this.i42_1;
        return new (ApolloRequest())(this.h42_1, tmp0_elvis_lhs == null ? uuid4() : tmp0_elvis_lhs, this.j42_1, this.k42_1, this.l42_1, this.n42_1, this.o42_1, this.m42_1, this.p42_1, this.q42_1, this.r42_1, this.s42_1, this.t42_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloRequestClass;
function ApolloRequest() {
  if (ApolloRequestClass === VOID) {
    class $ {
      constructor(operation, requestUuid, executionContext, httpMethod, httpHeaders, sendApqExtensions, sendDocument, enableAutoPersistedQueries, canBeBatched, ignoreApolloClientHttpHeaders, retryOnError, failFastIfOffline, sendEnhancedClientAwareness) {
        this.i43_1 = operation;
        this.j43_1 = requestUuid;
        this.k43_1 = executionContext;
        this.l43_1 = httpMethod;
        this.m43_1 = httpHeaders;
        this.n43_1 = sendApqExtensions;
        this.o43_1 = sendDocument;
        this.p43_1 = enableAutoPersistedQueries;
        this.q43_1 = canBeBatched;
        this.r43_1 = ignoreApolloClientHttpHeaders;
        this.s43_1 = retryOnError;
        this.t43_1 = failFastIfOffline;
        this.u43_1 = sendEnhancedClientAwareness;
      }
      v43() {
        return this.w43(this.i43_1);
      }
      w43(operation) {
        return (new (Builder())(operation)).v42(this.j43_1).w42(this.k43_1).y42(this.l43_1).z42(this.m43_1).b43(this.n43_1).c43(this.o43_1).d43(this.p43_1).e43(this.q43_1).f43(this.s43_1).g43(this.t43_1).x42(this.r43_1).h43(this.u43_1);
      }
    }
    initMetadataForClass($, 'ApolloRequest');
    ApolloRequestClass = $;
  }
  return ApolloRequestClass;
}
//region block: exports
export {
  Builder as Builder32honxq3tatym,
};
//endregion

//# sourceMappingURL=ApolloRequest.mjs.map
